<div fxLayout="row" fxLayoutAlign="space-between center">
  <div style="width: 100%">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Detalle de localización </mat-panel-title>
          <!-- <mat-panel-description> Currently I am </mat-panel-description> -->
        </mat-expansion-panel-header>

        <div fxLayout="row">
          <div fxFlex="100">
            <mat-form-field appearance="outline">
              <mat-label>País</mat-label>
              <input
                matInput
                disabled
                [(ngModel)]="level_country"
                (change)="onChangeLvl()"
              />
            </mat-form-field>
          </div>
        </div>

        <!--  -->

        <div fxLayout="row">
          <div fxFlex="100">
            <mat-form-field appearance="outline">
              <mat-label>División administrativa de primer nivel </mat-label>
              <input
                matInput
                type="text"
                [(ngModel)]="level_1"
                (change)="onChangeLvl()"
                [disabled]="is_disabled"
              />
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row">
          <div fxFlex="100">
            <mat-form-field appearance="outline">
              <mat-label>División administrativa de segundo nivel</mat-label>
              <input
                matInput
                type="text"
                [(ngModel)]="level_2"
                (change)="onChangeLvl()"
                [disabled]="is_disabled"
              />
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row">
          <div fxFlex="100">
            <mat-form-field appearance="outline">
              <mat-label>División administrativa de tercer nivel</mat-label>
              <input
                matInput
                type="text"
                [(ngModel)]="level_3"
                (change)="onChangeLvl()"
                [disabled]="is_disabled"
              />
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row">
          <div fxFlex="100">
            <mat-form-field appearance="outline">
              <mat-label>División administrativa de cuarto nivel</mat-label>
              <input
                matInput
                type="text"
                [(ngModel)]="level_4"
                (change)="onChangeLvl()"
                [disabled]="is_disabled"
              />
            </mat-form-field>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
<br />
<div fxLayout="row" fxLayoutAlign="space-between center">
  <div fxFlex="100">
    <mat-form-field appearance="outline">
      <mat-label>Lugar, detalle de la ubicación</mat-label>
      <input
        matInput
        type="text"
        name="address"
        [(ngModel)]="location_object.address"
        disabled
      />
    </mat-form-field>
  </div>
</div>
<div fxLayout="row" fxLayoutAlign="space-between center">
  <div fxFlex="33">
    <mat-form-field appearance="outline">
      <mat-label>Latitud</mat-label>
      <input
        matInput
        type="text"
        name="location_lat"
        [(ngModel)]="location_object.location_lat"
        (change)="onChangeLatLon()"
      />
    </mat-form-field>
  </div>
  <div fxFlex="33">
    <mat-form-field appearance="outline">
      <mat-label>Longitud</mat-label>
      <input
        matInput
        type="text"
        name="location_lon"
        [(ngModel)]="location_object.location_lon"
        (change)="onChangeLatLon()"
      />
    </mat-form-field>
  </div>
  <div fxFlex="33">
    <mat-form-field appearance="outline">
      <mat-label>Porcentaje de area plantada (%)</mat-label>
      <input
        matInput
        type="text"
        title="Porcentaje de area plantada (%)"
        name="percentage_of_planted_area"
        [(ngModel)]="location_object.percentage_of_planted_area"
        disabled
      />
    </mat-form-field>
  </div>
</div>

<div id="location">
  <div
    id="map"
    leaflet
    [leafletOptions]="mapOptions"
    [style.height]="height_value"
    [leafletLayersControl]="layersControl"
    (leafletMapReady)="onMapReady($event)"
    (leafletClick)="onMapClick($event)"
  ></div>
</div>
